import React from 'react';
import type { ShapeVariant, SizeVariant } from 'ui/components/ControlButton/types';
import { LoadingRecordButtonBase, LoadingRecordIcon } from './view';

interface LoadingRecordButtonProps {
    buttonShape?: ShapeVariant;
    buttonSize?: SizeVariant;
}

export const LoadingRecordButton = ({ buttonShape, buttonSize }: LoadingRecordButtonProps) => {
    return (
        <LoadingRecordButtonBase shape={buttonShape} size={buttonSize}>
            <LoadingRecordIcon icon="icSpinnerLarge" colorVariant="bright" />
        </LoadingRecordButtonBase>
    );
};
